import { MantineTheme, createStyles } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
  subtext: {
    fontSize: "22px",
    fontWeight: 500,
  },
  instructionHeading: {
    marginTop: "15px",
    left: "68px",
    fontSize: "17px",
    fontWeight: 500,
    lineHeight: "20.71px",
    textAlign: "justify",
    marginBottom: "5px",
  },
  instructionHeading2: {
    marginTop: "30px",
    left: "68px",
    fontSize: "17px",
    fontWeight: 500,
    lineHeight: "20.71px",
    textAlign: "justify",
    marginBottom: "5px",
  },
  subSmallText: {
    fontSize: "15px",
  },
  card: {
    backgroundColor: "#e5efffff",
    marginTop: "10px",
  },
  th: {
    border: "1px solid #ede4e4ff",
    backgroundColor: "#f7f6f6ff",
    fontWeight: 600,
    padding: "5px",
  },
  td: {
    padding: "5px",
    backgroundColor: "#f7f6f6ff",
  },
  header: {
    fontSize: "15px",
    fontWeight: 500,
    paddingTop: "15px",
  },
  div: {
    margin: "10px",
  },
  instruction: {
    fontSize: "12px",
  },
  container: {
    position: "relative",
    overflow: "hidden",
    height: "auto",
  },
  modalTitle: {
    fontWeight: 500,
    fontSize: "16px",
    padding: "7px",
  },
  imageSize: {
    width: "30%",
    height: "30%",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  modalContainer: {},
  reasonList: {
    paddingLeft: "20px",
    margin: 0,
    listStyleType: "disc",
    listStylePosition: "outside",
  },
  reasonItem: {
    marginBottom: "6px",
    lineHeight: "1.4",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
}));
